module.exports = __webpack_public_path__ + "img/Kyle Farren, Director Corporate Relation.8379d40b.webp";